(() => {
  const SESSION_KEY = 'afid';
  const LEGACY_LOCAL_STORAGE_KEY = 'shopify_af_id';

  const SEO_AFIDS = {
    'google.co.jp': '10SEO-G',
    'google.com': '10SEO-G',
    'search.yahoo.co.jp': '10SEO-Y',
    'bing.com': '10SEO-B'
  };

  const normalizeHost = (host) =>
    String(host || '').toLowerCase().replace(/^www\./, '');

  /*
   * 以前の「期限なし版」で保存したlocalStorageを削除。
   * 今後はsessionStorageのみを使用する。
   */
  try {
    localStorage.removeItem(LEGACY_LOCAL_STORAGE_KEY);
  } catch (error) {
    console.warn('[AFID] 旧localStorageを削除できませんでした:', error);
  }

  const getParameterAfid = () => {
    const params = new URLSearchParams(window.location.search);

    for (const [key, value] of params.entries()) {
      if (key.toLowerCase() === 'af_id') {
        return String(value || '').trim().slice(0, 255);
      }
    }

    return '';
  };

  const getReferrerUrl = () => {
    if (!document.referrer) return null;

    try {
      return new URL(document.referrer);
    } catch (_) {
      return null;
    }
  };

  const getSeoAfid = (referrerUrl) => {
    if (!referrerUrl) return '';

    const referrerHost = normalizeHost(referrerUrl.hostname);

    for (const [domain, afid] of Object.entries(SEO_AFIDS)) {
      const targetHost = normalizeHost(domain);

      if (
        referrerHost === targetHost ||
        referrerHost.endsWith(`.${targetHost}`)
      ) {
        return afid;
      }
    }

    return '';
  };

  const isSameSite = (referrerUrl) => {
    if (!referrerUrl) return false;

    const currentHost = normalizeHost(window.location.hostname);
    const referrerHost = normalizeHost(referrerUrl.hostname);

    return (
      referrerHost === currentHost ||
      referrerHost.endsWith(`.${currentHost}`) ||
      currentHost.endsWith(`.${referrerHost}`)
    );
  };

  const getSessionAfid = () => {
    try {
      const value = sessionStorage.getItem(SESSION_KEY);
      return !value || value === 'null' ? '' : value.trim();
    } catch (error) {
      console.warn('[AFID] sessionStorageを読み込めませんでした:', error);
      return '';
    }
  };

  const setSessionAfid = (afid) => {
    try {
      sessionStorage.setItem(SESSION_KEY, afid);
    } catch (error) {
      console.warn('[AFID] sessionStorageへ保存できませんでした:', error);
    }
  };

  const parameterAfid = getParameterAfid();
  const referrerUrl = getReferrerUrl();
  const organicAfid = getSeoAfid(referrerUrl);
  const currentSessionAfid = getSessionAfid();

  let afid = '';
  let source = 'none';

  /*
   * 参考JSと同じ優先順位
   *
   * 1. URLパラメータ af_id
   * 2. Google / Yahoo! / Bing の自然検索
   * 3. その他の外部サイト（セッション内にAFIDがない初回のみ）
   * 4. セッション内に保存済みのAFID
   */
  if (parameterAfid) {
    afid = parameterAfid;
    source = 'parameter';
    setSessionAfid(afid);
  } else if (organicAfid) {
    afid = organicAfid;
    source = 'organic';
    setSessionAfid(afid);
  } else if (
    referrerUrl &&
    !isSameSite(referrerUrl) &&
    !currentSessionAfid
  ) {
    afid = 'OTHER-99';
    source = 'external';
    setSessionAfid(afid);
  } else {
    afid = currentSessionAfid;
    source = afid ? 'session' : 'none';
  }

  const updateCartAfid = async (value) => {
    const cartResponse = await fetch(
      window.Shopify.routes.root + 'cart.js',
      { credentials: 'same-origin' }
    );

    if (!cartResponse.ok) {
      throw new Error(`カート取得エラー: ${cartResponse.status}`);
    }

    const cart = await cartResponse.json();
    const currentCartAfid = cart.attributes?.af_id || '';

    if (currentCartAfid === value) {
      console.log('[AFID] カート変更なし:', {
        afid: value || null,
        source
      });
      return;
    }

    const updateResponse = await fetch(
      window.Shopify.routes.root + 'cart/update.js',
      {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          attributes: {
            /*
             * 新しいセッションにAFIDがない場合は空文字でクリアし、
             * 前セッションのAFIDがカートに残るのを防ぐ。
             */
            af_id: value
          }
        })
      }
    );

    if (!updateResponse.ok) {
      throw new Error(`AFID更新エラー: ${updateResponse.status}`);
    }

    const updatedCart = await updateResponse.json();

    console.log('[AFID] カートを更新しました:', {
      afid: updatedCart.attributes?.af_id || null,
      source
    });
  };

  updateCartAfid(afid).catch((error) => {
    console.error('[AFID] 処理に失敗しました:', error);
  });
})();
